import { defineStore, setActivePinia } from "pinia";
import layoutConfig from "@/config/layoutConfig";
import globleConfig, { ModuleOpenStateControl } from "@/config/config.js";
import GlobalAudioPlayer from "@/components/media/audioPlayer/GlobalAudioPlayer.js";
import dateTimeUtil from "@/utils/dateTime.js";
import tools from "@/utils/tools.js";

const useCreateRenderType = defineStore({
  id: "createRenderType",
  state: () => {
    return {
      createRenderType: 'pc',
    
    };
  },
  actions: {
    setRenderType(renderType) {
      this.createRenderType = renderType;
    },
  },
});

export default useCreateRenderType;
